export const useDefaultData = ({Helpers}) => {

    const {getCurrentDate} = Helpers

    const defaultFormGlobal = {
        idventa: 0,
        idvehiculo: 0,
        idcliente: 0,
        fecha_venta: '',
        monto_venta: '',
        clean_monto_venta: 0,

        tipo: '',
        marca: '',
        modelo: '',
        linea: '',
        color: '',
        motorCC: '',
        matricula: '',
        motorNo: '',
        chasis: '',
        costo_total: '',

        aprobacion_check: 'Pendiente Aprobacion',
        aprobacion_fecha: getCurrentDate(),
        aprobacion_observaciones: '',
        files: [],
        fileRejections: [],
        acceptedFiles: [],

    }

    const optionsAprobacionCheck = [
        { value: 'Aprobado', label: 'Aprobado' },
        { value: 'Rechazado', label: 'Rechazado' },
        { value: 'Pendiente Aprobacion', label: 'Pendiente Aprobacion' },
        { value: 'Devuelto a Gestor', label: 'Devuelto a Gestor' },
    ];


    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormDeposit = {
        iddeposit: '',
        idcaja: '',
        idbanco: '',
        boleta_numero: '',
        boleta_foto_path: '',
        boleta_foto_originalname: '',
        aprobacion_referencia_ach: '',
        aprobacion_observaciones: '',
        deposito_dolares: '',
        deposito_fecha: getCurrentDate(),
        deposito_moneda: '',
        deposito_monto: '',
        deposito_observaciones: '',
        deposito_quetzales: '',
        deposito_tipo_cambio: 7.8,
        movimiento_tipo: '',
        aprobacion_check: '',
        files: [],
        fileRejections: [],
        acceptedFiles: [],

        clean_deposito_monto: 0,
        clean_deposito_quetzales: 0,
        clean_deposito_dolares: 0,
    }

    const defaultFormPreInventory = {
        idvehicledeposit: 0,
        valor: '',
        marca: '',
        modelo: '',
        linea: '',
        color: '',
        matricula: '',
        chasis: '',

        clean_valor: 0,
    }

    const optionsTypeMoneda = [
        { value: 'QUETZAL', label: 'QUETZAL' },
        { value: 'DOLAR', label: 'DOLAR' },
    ];

    const optionsTypePayment = [
        { value: 'EFECTIVO', label: 'EFECTIVO' },
        { value: 'DEPOSITO', label: 'DEPOSITO' },
    ];

    const optionsAprobacionDeposit = [
        { value: 'APROBADO', label: 'APROBADO' },
        { value: 'PENDIENTE', label: 'PENDIENTE' },
        { value: 'RECHAZADO', label: 'RECHAZADO' },
    ];



    return Object.freeze({
        defaultFormGlobal,
        optionsAprobacionCheck,
        defaultDataModal,
        defaultFormDeposit,
        optionsTypeMoneda,
        optionsTypePayment,
        optionsAprobacionDeposit,
        defaultFormPreInventory
    })
}